import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  align?: CSSProperties["alignItems"];
  className?: HTMLAttributes<HTMLAllCollection>["className"];
  id?: HTMLAttributes<HTMLAllCollection>["id"];
  justify?: CSSProperties["justifyContent"];
}>;

export default function MainFlexContainer({
  align,
  children,
  className,
  id,
  justify,
}: Props) {
  const styles: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: align || "center",
    gap: "var(--page-gap)",
    justifyContent: justify || "start",

    maxWidth: "var(--page-container-max-width)",
    padding: "var(--page-padding-vertical) var(--page-padding-horizontal)",
    margin: "0 auto",
  };
  return (
    <main className={className} id={id} style={styles}>
      {children}
    </main>
  );
}
